import { Routes } from '@angular/router';
import { v2On } from '../v2/ui-v2.guard';

export const orgProfileRoutes: Routes = [
  {
    path: 'org-profile',
    canMatch: [v2On],
    loadComponent: () => import('../v2/pages/org/org-profile-v2.page').then(m => m.OrgProfileV2Page),
  },
  {
    path: 'org-profile',
    loadComponent: () => import('./org-profile.page').then((m) => m.OrgProfilePage),
  },
];
